import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})

export class MetaService {
    constructor(@Inject(DOCUMENT) private dom, private meta: Meta) { }

    createCanonicalURL(route: string, url?: string) {
        //console.log("url=" + url + " route=" + route);
        if (!url.endsWith("/"))
            url += "/";
        if (!route.endsWith("/"))
            route += "/";
        if ((route.localeCompare(url) === 0)) {
            return;
        }
        //        console.log("url=" + url + " route=" + route);
        url = "https://lawshelf.com" + url;
        const canURL = url == undefined ? this.dom.URL : url;
        this.removeCanonicalURL();
        let link: HTMLLinkElement = this.dom.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('id', 'theCanonLink');
        this.dom.head.appendChild(link);
        link.setAttribute('href', canURL);
    }

    removeTag(id: string) {
        if (this.dom.getElementById(id))
            this.dom.getElementById(id).remove();
    }

    addMetaTags(theUrl: string, description: string, logoUrl: string, title: string, facebookId: string) {
        let shortDescription = description;
        if (description) {
            let endIndex = shortDescription.indexOf("</p>");
            if (endIndex > 0) {
                shortDescription = shortDescription.substring(0, endIndex + 4);
            } else if (shortDescription.length > 600) {
                endIndex = shortDescription.indexOf(".");
                if (endIndex > 25)
                    shortDescription = shortDescription.substring(0, endIndex);
            }
        }

        var ids = ['mt1', 'mt2', 'mt3', 'mt4', 'mt5', 'mt6', 'mt7', 'mt8', 'mt9'];
        ids.forEach(theId => this.removeTag(theId));
        this.meta.addTag({ id: 'mt1', property: 'og:type', content: 'website' });
        if (theUrl)
            this.meta.addTag({ id: 'mt2', property: 'og:url', content: theUrl });
        if (description) {
            this.meta.addTag({ id: 'mt3', name: 'description', property: 'og:description', content: shortDescription });
            this.meta.addTag({ id: 'mt9', name: 'twitter:description', content: shortDescription });
        }
        if (logoUrl) {
            this.meta.addTag({ id: 'mt4', property: 'og:image', content: logoUrl });
            this.meta.addTag({ id: 'mt8', name: "twitter:image", content: logoUrl });
            //            this.meta.addTag({ id: 'mt10', name: "twitter:image:src", content:  logoUrl });
        }
        if (title)
            this.meta.addTag({ id: 'mt5', property: 'og:title', name: "twitter:title", content: title });
        if (facebookId)
            this.meta.addTag({ id: 'mt6', property: 'fb:app_id', content: facebookId });
        this.meta.addTag({ id: 'mt7', property: 'twitter:card', content: "summary_large_image" });
    }

    removeCanonicalURL() {
        try {
            if (this.dom.getElementById("theCanonLink"))
                this.dom.getElementById("theCanonLink").remove();
        } catch (e) {
            console.log("caught exception in removeCanonicalURL");
        }
    }

    addNoOpenerTag() {
        try {
            var theLinks = this.dom.getElementsByTagName("a");
            var index;
            for (index = 0; index < theLinks.length; index++) {
                if ((theLinks[index].href.search("localhost") < 0 && theLinks[index].href.search("lawshelf") < 0) || theLinks[index].href.search("facebook") >= 0) {
                    theLinks[index].rel = "noopener";
                }
            }

        } catch (e) {
            console.log("caught exception in addNoOpenerTag");
        }
    }

} 